class MediaGalleryLanding extends HTMLElement {
  constructor() {
    super();
    this.thumbnails = this.querySelectorAll('.thumbnail');
    this.mainImages = this.querySelectorAll('.main-image');
    this.zoomTriggers = this.querySelectorAll('.zoom-trigger');
    this.modal = document.getElementById('ImageModal');
    this.modalImage = document.getElementById('ModalImage');
    this.modalClose = document.getElementById('ModalClose');

    if (this.thumbnails.length > 0 && this.mainImages.length > 0) {
      this.initGallery();
    }
    if (this.zoomTriggers.length > 0) {
      this.initModal();
    }
  }

  initGallery() {
    this.thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {
        const index = thumbnail.dataset.index;

        if (index) {
          thumbnail.classList.add('active');
          const mainImage = this.querySelector(`.main-image[data-index="${index}"]`);
          if (mainImage) {
            mainImage.classList.add('active');
          }

          requestAnimationFrame(() => {
            this.clearActiveStates(thumbnail, mainImage);
          });
        }
      });
    });
  }

  initModal() {
    this.zoomTriggers.forEach(trigger => {
      trigger.addEventListener('click', (event) => {
        const image = event.currentTarget;
        this.openModal(image.src, image.alt);
      });
    });

    this.modalClose.addEventListener('click', () => {
      this.closeModal();
    });
  }

  openModal(imageSrc, imageAlt) {
    this.modalImage.src = imageSrc;
    this.modalImage.alt = imageAlt;
    this.modal.removeAttribute('hidden');
    this.modal.setAttribute('open', '');
    document.body.style.overflow = 'hidden'; // Empêche le scroll sur la page
  }

  closeModal() {
    this.modal.setAttribute('hidden', '');
    this.modal.removeAttribute('open');
    document.body.style.overflow = ''; // Rétablit le scroll sur la page
  }

  clearActiveStates(exceptThumbnail, exceptMainImage) {
    this.thumbnails.forEach(thumbnail => {
      if (thumbnail !== exceptThumbnail) {
        thumbnail.classList.remove('active');
      }
    });
    this.mainImages.forEach(image => {
      if (image !== exceptMainImage) {
        image.classList.remove('active');
      }
    });
  }
}

// Définition du custom element
customElements.define('media-gallery-landing', MediaGalleryLanding);

